// src/pages/user/Plans.tsx
import UserPlans from "../../components/user/Plans";

export default function PlansPage() {
  return <UserPlans />;
}